import React from "react";
import BlogsCard from "./BlogsCard";
import Header from "./Header";
import { useSelector } from "react-redux";
import {
  AUTHORSEARCH,
  CATEGORYSEARCH,
  SEARCH,
} from "../redux/search_bar/actionTypes";

export default function Blogs() {
  const search = useSelector((state) => state.search);
  const blogs = useSelector((state) => state.blog);

  console.log(search.text, blogs);
  return (
    <section className="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8">
      <div className="absolute inset-0">
        <div className="bg-white h-1/3 sm:h-2/3" />
      </div>
      <div className="relative max-w-7xl mx-auto">
        <Header />
        <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
          {blogs.map((blog) => {
            if (search.type === SEARCH) {
              if (blog.title.toLowerCase().includes(search.text)) {
                return <BlogsCard blog={blog} key={blog.id} />;
              }
            } else if (search.type === CATEGORYSEARCH) {
              if (blog.category.toLowerCase().includes(search.text)) {
                return <BlogsCard blog={blog} key={blog.id} />;
              }
            } else if (search.type === AUTHORSEARCH) {
              if (blog.author_name.toLowerCase().includes(search.text)) {
                return <BlogsCard blog={blog} key={blog.id} />;
              }
            } else {
              return <BlogsCard blog={blog} key={blog.id} />;
            }
          })}
        </div>
      </div>
    </section>
  );
}
